import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function Dashboard(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarType={props?.sidebarType}
      />
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className="hide-scrollbar">
          <div className="px-4 sm:px-6 lg:px-8 pt-2 pb-4  w-full max-w-9xl mx-auto">
            {props?.children}
          </div>
        </main>
      </div>
    </div>
  );
}
